import React from 'react'; // useState
const PlanComponent = props => {
	const { setSelected, selected, plan, setSliderVal, pricePlan } = props;
	const {
		id,
		title,
		//  billingCycle, price, desc,
		benifits,
		maxLimit,
	} = plan;
	const disabled = !pricePlan.pricing[id];
	return (
		<div className='wrapper-plan'>
			<div
				className='plan-wrapper'
				onClick={e => {
					if (!disabled) {
						if (pricePlan.pricing[id]) {
							setSelected(id);
						} else {
							setSliderVal(maxLimit);
						}
					}
				}}
			>
				<label className='plan-box' htmlFor={id}>
					<input
						type='radio'
						name='radio'
						id={id}
						checked={selected === id}
						disabled={disabled}
						onChange={() => {}}
					/>
					<div className='plan-title'>
						<div className='plan-check-box'></div>
						<span className='fs-3 fw-bolder'>{title}</span>
					</div>
					<div className='list-wrapper'>
						<h6 className='plan-details-title'>Includes:</h6>
						{benifits.map(item => (
							<span className='details-title fs-5' key={item}>
								<svg
									aria-hidden='true'
									focusable='false'
									data-prefix='fas'
									data-icon='check'
									className='svg-inline--fa fa-check fa-w-16'
									role='img'
									xmlns='http://www.w3.org/2000/svg'
									viewBox='0 0 512 512'
								>
									<path
										fill='#a1a5b7'
										d='M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z'
									></path>
								</svg>
								{item}
							</span>
						))}
					</div>
				</label>
			</div>
		</div>
	);
};
const PlanList = props => {
	const { selected, setSelected, setSliderVal, pricePlan, PLANS } = props;

	return (
		<>
			<div className='plan-container'>
				{Object.values(PLANS).map(plan => (
					<PlanComponent
						setSelected={setSelected}
						selected={selected}
						plan={plan}
						setSliderVal={setSliderVal}
						key={plan.id}
						pricePlan={pricePlan}
					/>
				))}
			</div>
		</>
	);
};

export default PlanList;
